import React, { PureComponent } from 'react';

/**
 * Containers.
 */
import Header from 'modules/landing/containers/header';

/**
 * Components.
 */
import LandingSection from 'components/landing-section';
import Button from 'components/button';

import { ChevronDownIcon } from 'mdi-react';

/**
 * Style.
 */
import './first-section.scss';

import * as Scroll from 'react-scroll';

class FirstSection extends PureComponent {
  onScrollDownClick = () => {
    Scroll.to(200);
  }

  render() {
    const { goTo, goToAfiliation, goToAbout } = this.props;

    return (
      <LandingSection className="first-section">
        <div className="mask" />
        <div className="animated-clouds" />
        <Header
          goTo={goTo}
        />
        <div className="first-section-content-wrapper">
          <div className="first-section-content-header">
            Antiga e Mística Ordem Rosacruz
          </div>
          <hr />
          <div className="first-section-content">
            Somos uma organização internacional, de natureza filosófica,
            iniciática e tradicional, que perpetua o Conhecimento dos iniciados
            do antigo Egito e, de um modo geral, a gnose secreta que os grandes
            pensadores têm transmitido desde a mais remota antiguidade.
          </div>
          <div className="first-section-content-buttons">
            <Button
              orange
              onClick={goToAfiliation}
            >
              QUERO ME AFILIAR
            </Button>
            <div className="secondary-button">
              <Button onClick={goToAbout}>SAIBA MAIS</Button>
            </div>
          </div>
        </div>
        <Scroll.Link to="second-section" smooth>
          <ChevronDownIcon color="rgb(19, 75, 112)" size={72} className="arrow-down" />
        </Scroll.Link>
      </LandingSection>
    );
  }
}

export default FirstSection;
